import type { ReactNode } from "react";

import { endSession } from "../api/platformSession";
import { usePlatformSession } from "../usePlatformSession";

/**
 * The frame around the Healtrics console (ADR-024).
 *
 * A dark bar rather than the portal's white sidebar. The two are served from
 * one origin and somebody will switch between them mid-demonstration, so they
 * must not be mistakeable for each other at a glance. The line about what this
 * cannot reach is part of the frame rather than a note on one screen, because
 * it is true on all of them.
 */
export function PlatformShell({ children }: { children: ReactNode }) {
  const { who } = usePlatformSession();

  return (
    <div className="plat">
      <header className="plat-bar">
        <p className="plat-mark">
          <span>HEALTRICS</span>
          <span className="plat-tag">Admin</span>
        </p>
        <p className="plat-note">
          Above every clinic company. Reaches no patient record in any of them.
        </p>
        <div className="plat-who">
          {who && <span>{who}</span>}
          <button type="button" className="link" onClick={endSession}>
            Sign out
          </button>
        </div>
      </header>
      <main className="plat-main">{children}</main>
    </div>
  );
}
